// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b0daa2f8","462":"a4638254","470":"de8f0625","651":"f67638b5","847":"9b034b9c"}[chunkId] + ".chunk.js";
};